import { Text } from '@chakra-ui/react';

const Body2 = ({ children, bold = false, ...rest }) => (
  <Text textStyle="b2" fontWeight={bold ? 'bold' : 'normal'} color="black" {...rest}>
    {children}
  </Text>
);

export default Body2;
